import { markRaw } from 'vue';
import WidgetTepSet from '@/views/tep/tep-grid/components/widgets/widget-tep-net.vue';
import WidgetNagrRasxWater from '@/views/tep/tep-grid/components/widgets/widget-nagr-rasx-water.vue';
import WidgetNagrRasxPar from '@/views/tep/tep-grid/components/widgets/widget-nagr-rasx-par.vue';
import WidgetParProvod from '@/views/tep/tep-grid/components/widgets/widget-paroprovod.vue';
import WidgetTeplopoteri from  '@/views//tep/tep-grid/components/widgets/widget-teplopoteri.vue';
import WidgetUzelUcheta from '@/views/tep/tep-grid/components/widgets/widget-uzel-ucheta.vue';

const list = [
    {
        name: 'Тепловые сети',
        caption: ['name'],
        icon: '/infoenergo/assets/tep/widget/par-tep-set.svg',
        kod_vid_r: [50],
        isGrid: true,
        component: WidgetTepSet,
    },
    {
        name: 'Паропроводы',
        caption: ['name'],
        icon: '/infoenergo/assets/tep/widget/par-tep-set.svg',
        kod_vid_r: [55],
        isGrid: true,
        component: WidgetParProvod,
    },
    {
        name: 'Нагрузки и расходы (вода)',
        caption: ['name'],
        icon: '/infoenergo/assets/tep/widget/nagr-rasx-water.svg',
        kod_vid_r: [10, 20, 30, 40, 41, 42, 50, 22510000],
        isGrid: false,
        component: WidgetNagrRasxWater,
        width: '1200px'
    },
    {
        name: 'Нагрузки и расходы (пар)',
        caption: ['name'],
        icon: '/infoenergo/assets/tep/widget/nagr-rasx-par.svg',
        kod_vid_r: [10, 25, 35, 45, 46, 55],
        isGrid: false,
        component: WidgetNagrRasxPar,
        width: '800px'
    },
    {
        name: 'Теплопотери',
        caption: ['name'],
        icon: '/infoenergo/assets/tep/widget/teplopoteri.svg',
        kod_vid_r: [50, 55],
        isGrid: false,
        component: WidgetTeplopoteri,
        width: '1200px'
    },
    {
        name: 'Узел учета',
        caption: ['name'],
        icon: '/infoenergo/assets/tep/widget/uzel-ucheta.svg',
        kod_vid_r: [55],
        isGrid: true,
        component: WidgetUzelUcheta,
    },

];
const useCardWidgetList = (kod_vid, pvName = null) => {
    let listPage = list.filter((item) => {
        return item.kod_vid_r.includes(kod_vid)
    })
    return listPage.map(widget => {
        const { component,  name, ...rest } = widget;
        return {
            ...rest,
            id: 'widget-' + Math.floor(Math.random() * Date.now()).toString(),
            visible: false,
            name: pvName && name === 'Паропроводы' ? `${name}: ${pvName}` : name,
            component: markRaw(component),
        };
    });
};

export default useCardWidgetList;
